import React from 'react';
import styled from '@emotion/styled';

import Icon from './CheckIcon';
import RadioIcon from './RadioIcon';
import { useCurrency } from '~Hooks';

const Wrapper = styled.div<{ isOutOfStock?: boolean }>`
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: solid 1px rgb(224, 224, 227);
  opacity: ${({ isOutOfStock }) => (isOutOfStock ? 0.5 : 1)};
`;

const Name = styled.strong`
  flex: 1;
  padding: 0 10px 0 0;
  color: rgb(33, 33, 36);
  font-weight: 600;
  letter-spacing: 0.24px;
  font-family: Eina01-SemiBold;
  font-size: 24px;
  line-height: 32px;

  @media (orientation: landscape) {
    font-size: 22px;
    line-height: 30px;
  }
`;

const Price = styled.strong`
  color: rgb(97, 97, 100);
  font-family: Eina01-Regular;
  font-size: 24px;
  font-weight: normal;
  line-height: 28px;
  text-align: right;

  @media (orientation: landscape) {
    font-size: 22px;
    line-height: 26px;
  }
`;

interface Props {
  onSelect: () => void;
  multi?: boolean;
  id: string;
  name: string;
  price: number;
  selected: boolean;
  isOutOfStock?: boolean;
}

const GroupItem = ({ name, price, onSelect, multi, selected, isOutOfStock }: Props) => {
  const currency = useCurrency();

  return (
    <Wrapper onClick={!isOutOfStock ? onSelect : undefined} isOutOfStock={isOutOfStock}>
      {multi ? <Icon active={selected} /> : <RadioIcon active={selected} />}
      <Name>{name}</Name>
      {price !== 0 && <Price>+{currency.format(price)}</Price>}
    </Wrapper>
  );
};

export default GroupItem;
